export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="py-3 text-center font-bold text-white bg-primary uppercase text-sm md:text-base">
      COPYRIGHT &copy; MEN EMPIRE 2015-{year}
    </footer>
  );
}
